import HTTPBase from "@/api/HTTPBase.js"
import api from "@/api/clientAPI.js"
// import _ from 'lodash'

let component = {
    api: null
}

component.setClientAPI = (c) =>  {
    component.api = c
    component.addInterceptors()
}


component.formFromDB = async (fid) => {
    let url = `${process.env.VUE_APP_API_BASEURL}/dataset/catalog_forms/${fid}`;
    let res = await HTTPBase.GET(url)
    return res.data
}


component.fetchVariable = (variableName, url) => {
    let r = HTTPBase.GET(url);
    r.then(res => {
        component.api.setVariable(variableName, res.data);
    });

    return r;
}

component.fetchVariableOnce = (variableName, url) => {
    let e = component.api.getVariable(variableName)
    return e ? e: component.fetchVariable(variableName, url)
}


component.guardarBorrador = async (propietario) => {
    let url = `${process.env.VUE_APP_API_BASEURL}/borrador`

    let borrador = {
        idFormulario: component.api.getSchema().id,
        propietario: propietario,
        formData: JSON.stringify(component.api.getFormData())
    }

    // window.console.log('enviando ..', borrador)
    // window.console.log('auth ..', component.api.getAuth())

    api.clearValidationErrors()
    let promise = HTTPBase.POST(url, borrador, {
        // responseType: 'arraybuffer',
        auth: component.api.getAuth()
    })

    HTTPBase.addErrorHandler(promise)

    try {
        let response = await promise
        // window.console.log('guardarBorrador response>', response)
        window.api.eventPublish(window.api.events.EVENT_ON_BORRADOR_ALMACENADO, {
            detail: response.data
        })
        return response
    } catch(err) {
        window.console.log('Error guardando borrador', err)
        throw err
    }
}

component.recuperarBorrador = (localizador) => {
    let url =  `${process.env.VUE_APP_API_BASEURL}/borrador/localizador/${localizador}`

    window.console.log('recuperando ..', localizador)

    let promise = HTTPBase.GET(url, {
        // responseType: 'arraybuffer',
        auth: component.api.getAuth()
    })

    // HTTPBase.addErrorHandler(promise)

    api.clearValidationErrors()

    const retValue = new Promise( (resolve, reject) => {
        promise.then(response => {
            window.console.log('recuperarBorrador response>', response)
            if (+response.data.idFormulario !== +component.api.getSchema().id) return reject({
                id: 9231,
                description: "El borrador se corresponde con otro formulario."
            })

            component.api.setFormData(response.data.formData)
            resolve(response.data)
        })

        promise.catch(err => {
            reject(err)
        })
    })

    return retValue
}

component.multipartPOST = HTTPBase.MultipartPOST,
component.multipartPUT = HTTPBase.MultipartPUT,


/*

component.getResguardoURL = (baseUrl, idpresentacion, uuid) => `${baseUrl}/${idpresentacion}/${uuid}`

component.descargarFichero = (url, filename) => {
    const promise = window.api.axios.get(url, {
        responseType: 'blob'
    })

    promise.then(response => {
        api.forceFileDownload(response, filename)
    })

    return promise
}

component.descargarResguardo = (baseUrl, idpresentacion, uuid) => {
    let api = component.api;

    api.clearValidationErrors();
    let url = component.getResguardoURL(baseUrl, idpresentacion, uuid)
    let promise = HTTPBase.POST(url, {
        fileName: "resguardo.pdf"
    }, {
        responseType: 'arraybuffer',
        auth: api.getAuth()
    })

    HTTPBase.addErrorHandler(promise)

    promise.then(response => {
        window.console.log('descargarResguardo response>', response)
        api.forceFileDownload(response)
    })

    return promise
}

component.forceFileDownload = (response, filename) => {
    eval('debugger')
    const url = window.URL.createObjectURL(new Blob([response.data || response ]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename || 'resguardo.pdf') //or any other extension
    document.body.appendChild(link)
    link.click()
}

*/


component.addInterceptors = () => {
    if(window.interceptorsAdded) return
    window.interceptorsAdded = true

    HTTPBase.addHttpResponseInterceptor((response) => {
        // window.console.log('component>', component)
        component.api.setVariable('http_activity', 0)
        document.body.classList.remove('bxhr')
        return response
    }, (error) => {
        window.console.log('http_activity response interceptor', error)
        component.api.setVariable('http_activity', 0)
        document.body.classList.remove('bxhr')
        window.api.eventPublish('http_activity_error', error)
        window.api.eventPublish('apirest_error', error)
        // debugger
    })

    HTTPBase.addHttpRequestInterceptor((request) => {
        // window.console.log('component>', component)
        component.api.setVariable('http_activity', 1)
        document.body.classList.add('bxhr')
        return request
    }, (error) => {
        window.console.log('http_activity request interceptor', error)
        component.api.setVariable('http_activity', 0)
        document.body.classList.remove('bxhr')
    })



}


export default component;